import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../types";
import { Conversation } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type ConversationOnSnapshotCollectionService<T> = (
  sessionId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: ConversationOnSnapshotCollectionService<
  EntityGet<Conversation>
> = (sessionId, opts: ListServiceOpts, callback, onError = () => {}) => {
  const collectionRef = collection(db, `/session/${sessionId}/conversation`);
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Conversation>,
                doc.metadata
              )
            ) as EntityGet<Conversation>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
